<template>
  <div class="w-full">
    <!-- mobile -->
    <div class="mobile-menu lg:hidden" id="mobile-menu" :class="{ isTransform: isOpen }">
      <h3 class="mb-4 text-NotoSansRegular main-title px-3 border-b" @click.prevent="openMenu">關於LiveABC</h3>
      <ul class="text-sm px-2 z-50 text-NotoSansBold textColorBlack  overflow-hidden" :class="{ open: isOpen, close: !isOpen }">
        <li class="pt-2 pb-1 textColorBlack">
          <h4 class="pl-3 bg-white" @click="openMobileMenu(0)">關於我們</h4>
          <ul @click="closeMenu" class="pb-2" :class="{ block: mobileIdx === 0, hidden: mobileIdx !== 0 }">
            <li class="py-1">
              <router-link :to="{ name: 'about' }" class="border-0" :class="{ textColorRed: $route.name === 'about' }">品牌故事</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'information' }" class="border-0" :class="{ textColorRed: $route.name === 'information' }">公司資訊</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'privacy' }" class="border-0" :class="{ textColorRed: $route.name === 'privacy' }">隱私權政策</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'policy' }" class="border-0" :class="{ textColorRed: $route.name === 'policy' }">服務條款</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'AI' }" class="border-0" :class="{ textColorRed: $route.name === 'AI' }">免責聲明</router-link>
            </li>
          </ul>
        </li>
        <li class="py-1">
          <h4 class="pl-3 bg-white" @click="openMobileMenu(1)">常見Q&amp;A</h4>
          <ul @click="closeMenu" class="pb-2" :class="{ block: mobileIdx === 1, hidden: mobileIdx !== 1 }">
            <li class="py-1">
              <router-link :to="{ name: 'service', params: { id: 'member' }}" class="border-0" :class="{ textColorRed: $route.params.id === 'member' }">會員常見問題</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'service', params: { id: 'shopping' }}" class="border-0" :class="{ textColorRed: $route.params.id === 'shopping' }">購物常見問題</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'service', params: { id: 'subscription' }}" class="border-0" :class="{ textColorRed: $route.params.id === 'subscription' }">雜誌訂閱問題</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'service', params: { id: 'return' }}" class="border-0" :class="{ textColorRed: $route.params.id === 'return' }">退換貨及退款</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'service', params: { id: 'smartPen' }}" class="border-0" :class="{ textColorRed: $route.params.id === 'smartPen' }">點讀筆常見問題</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'service', params: { id: 'eGUI' }}" class="border-0" :class="{ textColorRed: $route.params.id === 'smartPen' }">電子發票常見問題</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'service', params: { id: 'flash' }}" class="border-0" :class="{ textColorRed: $route.params.id === 'flash' }">互動學習軟體常見問題</router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'service', params: { id: 'mp3' }}" class="border-0" :class="{ textColorRed: $route.params.id === 'mp3' }">mp3音檔常見問題</router-link>
            </li>
          </ul>
        </li>
        <li class="py-1">
          <h4 class="pl-3 bg-white" @click="openMobileMenu(2)">聯絡我們</h4>
          <ul @click="closeMenu" class="pb-2" :class="{ block: mobileIdx === 2, hidden: mobileIdx !== 2 }">
            <li class="py-1">
              <router-link :to="{ name: 'connect' }" class="border-0" :class="{ textColorRed: $route.name === 'connect' }">客服信箱
            </router-link>
            </li>
            <li class="py-1">
              <router-link :to="{ name: 'contact' }" class="border-0" :class="{ textColorRed: $route.name === 'contact' }">業務合作洽談
            </router-link>
            </li>
          </ul>
        </li>
        <li class="pb-2 pt-1">
          <router-link :to="{ name: 'magazineSendBack' }" class="border-0 bg-white" :class="{ textColorRed: $route.name === 'magazineSendBack' }" @click.native="closeMenu">雜誌訂戶服務
          </router-link>
        </li>
        <li class="pb-2 pt-1">
          <a href="https://store.liveabc.com/CreditCardOrderForm中英文訂購單.doc" class="border-0 bg-white">空白訂單下載</a>
        </li>
      </ul>
    </div>
    <!-- web -->
    <div class="table-menu hidden lg:block" id="table-menu">
      <ul class="menu text-NotoSansBold textColorBlack">
        <li class="list cursor-pointer text-sm" ref="label0"
          :class="{ active: $route.name === 'about' || $route.name === 'privacy' || $route.name === 'policy' }">
          <a @click.prevent="openTable(0)">關於我們</a>
          <ul class="items textColorBlack">
            <li>
              <router-link :to="{ name: 'about' }" :class="{ textColorRed: $route.name === 'about' }">品牌故事</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'information' }" :class="{ textColorRed: $route.name === 'information' }">公司資訊</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'privacy' }" :class="{ textColorRed: $route.name === 'privacy' }">隱私權政策</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'policy' }" :class="{ textColorRed: $route.name === 'policy' }">服務條款</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'AI' }" :class="{ textColorRed: $route.name === 'AI' }">免責聲明</router-link>
            </li>
          </ul>
        </li>
        <li class="list cursor-pointer text-sm" ref="label1"
          :class="{ active: $route.name === 'service' }">
          <a @click.prevent="openTable(1)">常見Q&amp;A</a>
          <ul class="items font-normal textColorBlack">
            <li>
              <router-link :to="{ name: 'service', params: { id: 'member' }}" :class="{ textColorRed: $route.params.id === 'member' }">會員常見問題
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'service', params: { id: 'shopping' }}" :class="{ textColorRed: $route.params.id === 'shopping' }">購物常見問題
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'service', params: { id: 'subscription' }}" :class="{ textColorRed: $route.params.id === 'subscription' }">雜誌訂閱問題
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'service', params: { id: 'return' }}" :class="{ textColorRed: $route.params.id === 'return' }">退換貨及退款
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'service', params: { id: 'smartPen' }}" :class="{ textColorRed: $route.params.id === 'smartPen' }">點讀筆常見問題
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'service', params: { id: 'eGUI' }}" :class="{ textColorRed: $route.params.id === 'eGUI' }">電子發票常見問題
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'service', params: { id: 'AI_Digital_Learning' }}" :class="{ textColorRed: $route.params.id === 'AI_Digital_Learning' }">AI數位學習網常見問題
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'service', params: { id: 'AI_assistant' }}" :class="{ textColorRed: $route.params.id === 'AI_assistant' }">AI英語學習教室常見問題
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'service', params: { id: 'flash' }}" :class="{ textColorRed: $route.params.id === 'flash' }">互動學習軟體常見問題
              </router-link>
            </li>
            <!-- <li>
              <router-link :to="{ name: 'service', params: { id: 'markingAssignments' }}" :class="{ textColorRed: $route.params.id === 'markingAssignments' }">批改網常見問題
              </router-link>
            </li> -->
            <li>
              <router-link :to="{ name: 'service', params: { id: 'mp3' }}" :class="{ textColorRed: $route.params.id === 'mp3' }">mp3音檔常見問題
              </router-link>
            </li>
          </ul>
        </li>
        <li class="list cursor-pointer text-sm" ref="label2"
          :class="{ active: $route.name === 'connect' || $route.name === 'contact' }">
          <a @click.prevent="openTable(2)">聯絡我們</a>
          <ul class="items font-normal textColorBlack">
            <li>
              <router-link :to="{ name: 'connect' }" :class="{ textColorRed: $route.name === 'connect' }">客服信箱</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'contact' }" :class="{ textColorRed: $route.name === 'contact' }">業務合作洽談</router-link>
            </li>
          </ul>
        </li>
        <li class="notlist cursor-pointer text-sm" ref="label3">
          <router-link :to="{ name: 'magazineSendBack' }" :class="{ textColorRed: $route.name === 'magazineSendBack' }">雜誌訂戶服務</router-link>
        </li>
        <li class="notlist cursor-pointer text-sm" ref="label3">
          <a href="https://store.liveabc.com/CreditCardOrderForm中英文訂購單.doc" target="_blank">空白訂單下載</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',

  data () {
    return {
      isOpen: false,

      mobileIdx: null
    }
  },
  watch: {
  },
  mounted () {
  },

  methods: {
    openMenu () {
      this.isOpen = !this.isOpen
      this.mobileIdx = null
    },
    closeMenu () {
      this.isOpen = false
    },
    openTable (index) {
      let self = this
      self.$refs['label' + index].classList.toggle('active')
      for (let i = 0; i < 4; i++) {
        if (i !== index) {
          self.$refs['label' + i].classList.remove('active')
        }
      }
    },
    openMobileMenu (idx) {
      let self = this
      if (self.mobileIdx !== idx) {
        self.mobileIdx = idx
      } else if (self.mobileIdx === idx) {
        self.mobileIdx = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-menu {
  ul.menu{
    padding: 0;
    list-style: none;
    width: 100%;
    margin: 20px auto;
    clear: both;
    display: table;
    .list {
        font-size: 14px;
        border-bottom:1px solid #324252;
        position: relative;
        width: 100%;
        box-sizing: border-box;
        height: 50px;
        vertical-align: sub;
        background: #ffffff;
        clear: both;
        &:after{
          content: "";
          background-image:url('~@/assets/icon/bt_plus.png');
          background-size: auto;
          background-repeat: no-repeat;
          position: absolute;
          width:20px;
          height:20px;
          z-index: 10;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
        }
        a{
          text-decoration: none;
          padding: 12px 22px;
          display: block;
          height: 100%;
          box-sizing: border-box;
        }
        .items {
          height: 0px;
          overflow: hidden;
          transition:  .3s;
          li {
            padding-top: 0.25rem !important;
            padding-bottom: 0.25rem !important;
            a {
              padding: 0.25rem 4rem;
              transition:  300ms all;
            }
          }
        }
    }
    .notlist {
        font-size: 14px;
        border-bottom:1px solid #324252;
        position: relative;
        width: 100%;
        box-sizing: border-box;
        height: 50px;
        vertical-align: sub;
        background: #ffffff;
        clear: both;
        a {
          text-decoration: none;
          padding: 12px 22px;
          display: block;
          height: 100%;
          box-sizing: border-box;
        }
        .items {
          height: 0px;
          overflow: hidden;
          transition:  .3s;
          li {
            padding-top: 0.25rem !important;
            padding-bottom: 0.25rem !important;
            a {
              padding: 0.25rem 4rem;
              transition:  300ms all;
            }
          }
        }
    }
    .active {
        >.items{
          display: block;
          background: #ffffff;
          padding: 0px;
          height: auto;
          color:rgb(0, 0, 0);
          transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
          transition: 200s;
          clear: both;
          float: left;
          width: 100%;
          li {
            list-style: none;
            a {
              padding: 0.25rem 2rem 0.25rem 2rem;
              font-weight: 400;
            }
          }
          li:last-child{
            padding-bottom: 0px;
            border-bottom: 1px solid #324252;
          }
        }
        > a {
          border-bottom: 1px solid #324252;
        }
    }
  }
}

// mobile
  .mobile-menu {
    display: none;
  }
  .mobile-menu li {
    position: relative;
  }
  .mobile-menu h3 {
    display: none;
  }
  .mobile-menu {
    display: block;
    position: relative;
    left: 0;
    margin: 0;
    width: auto;
  }
  .mobile-menu h3 {
    display: block;
    margin: 0;
    line-height: 36px;
    cursor: pointer;
    padding: 0 6px;
    background-color: rgb(255, 255, 255);
    padding: 0;
  }
  .mobile-menu {
    .main-title {
      border-color: #f6f6f6;
      &:after {
        content: "▼";
        float: right;
        transform: scaleY(.8);
        line-height: 36px;
      }
    }
    h3+ul {
      position: absolute;
      top: 37px;
      background-color: #f6f6f6;
      width: 100%;
    }
    h4 {
      position: relative;
      &:after {
        position: absolute;
        right: 8px;
        content: "▼";
        color: #d1d0d0;
        transform: scaleY(.8);
        line-height: 36px;
      }
    }
    a {
      display: block;
      line-height: 36px;
      padding: 0 10px;
      border-bottom: 1px solid #dcdcdc;
    }
    ul {
      display: block;
      line-height: 36px;
      padding: 0 10px;
    }
  }
  .isTransform {
    .main-title:after {
      content: "▲";
    }
  }
  .mobile-menu
  .mobile-menu li {
    margin-top: 0;
  }
  .open {
    animation-name: showMenu;
    animation-duration: 0.35s;
    animation-fill-mode: forwards;
  }
  .close {
    animation-name: hideMenu;
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }
  @keyframes showMenu {
    from {
      height: 0em;
    }
    to {
      height: auto;
    }
  }
  @keyframes hideMenu {
    from {
      height: auto;
    }
    to {
      height: 0;
    }
  }
</style>
